"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileRpc = void 0;
var FileRpc;
(function (FileRpc) {
    FileRpc.UpdateFunctionName = 'file.update';
})(FileRpc || (exports.FileRpc = FileRpc = {}));
